<template>
  <div class="block__tools">
    <button class="image-button tick-green" @click="$dispatch('selectall')" v-if="selectedImages.length !== itemsCount">Select All</button>
    <button class="image-button tick-green" @click="clearImagesList" v-else>Unselect All</button>
    <select class="select" v-model="selectedResolution">
      <option :value="resolution.Value" v-for="resolution in resolutions">{{resolution.Text}}</option>
    </select>
    <button class="icon-button basket-green" @click="basketImages(selectedImages)"></button>
    <button class="icon-button download-green" @click="downloadImages(selectedImages)"></button>
    <button class="icon-button mail-green" @click="mailImages(selectedImages)"></button>
  </div>
</template>

<script>
  import { downloadImages, basketImages, mailImages, clearImagesList } from "./ImagesActions";

  export default {
    props: ["resolutions", "itemsCount", "selectedResolution"],
    vuex: {
      getters: {
        selectedImages: state => state.selectedImages
      },
      actions: { downloadImages, basketImages, mailImages, clearImagesList }
    }
  };
</script>


// WEBPACK FOOTER //
// ImagesListToolbar.vue?4f49b11c